<template>
	<div class="table-section-container">
		<sf-data-table
			ref="dataTable"
			:pageUnit="10"
			:totalSize="groups.totalSize"
			:currentPage="groups.currentPage"
			paging
			:columns="column"
			:rows="menus"
			:addRowData="addRowData"
			:span-method="objectSpanMethod"
			selection
			@changedPage="changedPage"
		>
			<template v-slot:actionsLeft>
				<!-- test code -->
				<sf-button v-if="isButton_(onstieScrId, 'AD')" line icon="square-plus" :onClick="addAction">
					{{ getMessage_('SWCC000007') }}
				</sf-button>
				<sf-button v-if="isButton_(onstieScrId, 'CU')" line icon="file" :onClick="saveAction">
					{{ getMessage_('SWCC000327') }}
				</sf-button>
				<sf-button color="error" line v-if="isButton_(onstieScrId, 'CD')" icon="trash" :onClick="deleteAction">
					{{ getMessage_('SWCC000328') }}
				</sf-button>
				<!-- <sf-button line icon="trash" color="error" v-if="isButton_(scrId, 'CD')" :onClick="deleteAction">{{ getButtonMsg_(scrId, 'CD') }}</sf-button> -->
			</template>
		</sf-data-table>
	</div>
</template>

<script>
import { rootComputed } from '@/store/common/helpers';
import { serviceComputed, serviceMethods } from '@common/MenuManagement/store/helpers';
import * as yup from 'yup';
export default {
	props: {
		newName: {
			type: String,
			default: '[화면명 선택]'
		},
		//TODO: 데이터 조회에서 나오는 scrId와 props로 넘기는 scrId 변수명 일치 --> onsite&msa 소스코드 공통화 작업 필요
		onstieScrId: { type: String, default: '' }
	},
	data() {
		return {
			sortOrder: [],
			currentTableData: null,
			addRowData: {
				rowType: 'add',
				//TODO:
				scrId: '',
				scrName: this.newName,
				scrUrl: null,
				scrType: null,
				scrSort: null,
				scrDesc: '',
				useYn: null
			},
			editRow: {},
			screen: {}
		};
	},
	computed: {
		...rootComputed,
		...serviceComputed,
		rows() {
			return this.menus;
		},
		column() {
			return [
				{
					label: this.getMessage_('SWCC000320'),
					prop: 'scrId',
					field: 'scrId',
					minWidth: '180px',
					type: 'input',
					// edit: true, -> form 으로 변경
					form: {
						type: 'input',
						maxLength: 9,
						isDisabled: this.isDisabled,
						placeholder: 'Prefix (e.g S0000)'
					}
				},
				{
					label: this.getMessage_('SWCC000321'),
					prop: 'scrName',
					field: 'scrName',
					minWidth: '240px',
					type: 'render',
					sortable: false,
					clickEvent: this.scrNameClick,
					highlight: true
				},
				{
					label: this.getMessage_('SWCC000322'),
					prop: 'scrUrl',
					field: 'scrUrl',
					minWidth: '180px',
					type: 'input',
					// edit: true, -> form 으로 변경
					form: {
						type: 'input',
						maxLength: 200
					}
				},
				{
					label: this.getMessage_('SWCC000323'),
					prop: 'scrType',
					field: 'scrType',
					minWidth: '200px',
					form: {
						type: 'select',
						options: this.gridScrType
					}
				},
				{
					label: this.getMessage_('SWCC000144'),
					prop: 'scrSort',
					field: 'scrSort',
					minWidth: '120px',
					type: 'select',
					options: this.sortOrder,
					form: {
						type: 'input',
						maxLength: 200
					}
				},
				{
					label: this.getMessage_('SWCC000106'),
					prop: 'useYn',
					field: 'useYn',
					minWidth: '150px',
					form: {
						type: 'select',
						options: this.gridUseYnList
					}
				},
				{
					label: this.getMessage_('SWCC000324'),
					prop: 'scrDesc',
					field: 'scrDesc',
					minWidth: '150px',
					type: 'input',
					sortable: false,
					form: {
						type: 'input',
						maxLength: 1000
					}
				},
				{
					label: this.getMessage_('SWCC000004'),
					prop: 'regDt',
					field: 'regDt',
					minWidth: '240px',
					sortable: false
				},
				{
					label: this.getMessage_('SWCC000005'),
					prop: 'regId',
					field: 'regId',
					minWidth: '150px',
					sortable: false
				},
				{
					label: this.getMessage_('SWCC000143'),
					prop: 'regIP',
					field: 'regIP',
					minWidth: '150px',
					sortable: false
				},
				{
					label: this.getMessage_('SWCC000208'),
					prop: 'msgKey',
					minWidth: '180px',
					sortable: false
				}
			];
		},
		schema() {
			let length = 3;
			return yup.array().of(
				yup.object().shape({
					scrId: yup
						.string()
						.nullable()
						.required(this.$sf_formatString(this.getMessage_('SWCC000116'), [this.getMessage_('SWCC000320')]))
						.matches(/^[A-Z]{1}[0-9]{0,8}$/, this.getMessage_('SWCC000946')),
					scrName: yup
						.string()
						.nullable()
						.matches(/^.(?!화면명 선택).*$/, this.$sf_formatString(this.getMessage_('SWCC000116'), [this.getMessage_('SWCC000321')])),
					scrSort: yup.number().typeError(this.$sf_formatString(this.getMessage_('SWCC000895'), [this.getMessage_('SWCC000144')]))
				})
			);
		}
	},
	methods: {
		...serviceMethods,
		saveValidate(saveData) {
			this.schema
				.validate(saveData)
				.then(
					function (data) {
						return true;
					}.bind(this)
				)
				.catch(
					function (err) {
						this.$sf_showMessage({
							icon: 'error',
							title: this.getMessage_('SWCC000111'), //입력된 값이 잘못되었습니다.
							message: err.errors //사용자 권한 그룹 코드
						});
						return false;
					}.bind(this)
				);
		},

		isDisabled({ row }) {
			if (row.rowType && row.rowType === 'add') return false;
			else return true;
		},
		addAction() {
			for (let i = 0; i < this.rows.length; i++) {
				if (this.rows[i].rowType && this.rows[i].rowType === 'add') {
					return false;
				}
			}

			let addRowdata = { ...this.addRowData };
			this.rows.push(addRowdata);
			this.$refs.dataTable.getTable().toggleRowSelection(addRowdata);
			//this.setScrId();
		},
		saveAction() {
			// console.log(1);
			const selected = this.$refs.dataTable.getSelectedRows();

			if (selected.length < 1) {
				this.$sf_showMessage({
					icon: 'error',
					title: this.getMessage_('SWCC000109'),
					message: this.getMessage_('SWCC000110')
				}); //행을 선택해 주세요. / 선택된 데이터가 없습니다.
				return;
			}

			// console.log(2);
			this.$sf_showMessage({
				type: 'confirm',
				icon: 'confirm',
				title: this.getMessage_('SWCC000501'), //저장하시겠습니까?
				buttons: [{ title: this.getMessage_('SWCC000103'), clickFn: () => this.save(selected) }] //저장
			});
		},
		deleteAction() {
			// console.log('delete action');
			const selected = this.$refs.dataTable.getSelectedRows();
			if (selected.length < 1) {
				this.$sf_showMessage({
					icon: 'error',
					title: this.getMessage_('SWCC000109'),
					message: this.getMessage_('SWCC000110')
				});

				return;
			}
			this.$sf_showMessage({
				type: 'confirm',
				icon: 'confirm',
				title: this.getMessage_('SWCC000108'),
				buttons: [{ title: this.getMessage_('SWCC000107'), clickFn: () => this.delete(selected) }] //삭제
			});
		},
		delete(saveRows) {
			let sendData = {
				status: 1,
				plantCd: this.searchParams.plantCd,
				data: []
			};
			// console.log('@@@@ delte call');
			saveRows.forEach(row => {
				// console.log('@@@@ delte call');
				row.parentScrId = this.selectedMenu.scrId != undefined ? this.selectedMenu.scrId : null;
				row.scrLv = this.selectedMenu.scrLv != undefined ? parseInt(this.selectedMenu.scrLv) + 1 : 1;
				if (row.scrName == '[화면명 선택]') {
					row.scrName = '';
				}

				let pushSet = {
					scrId: row.scrId,
					scrName: row.scrName ? row.scrName : '',
					scrDesc: row.scrDesc ? row.scrDesc : '',
					parentScrId: row.parentScrId,
					scrLv: row.scrLv,
					scrSort: row.scrSort,
					scrUrl: row.scrUrl,
					useYn: 'N',
					regId: 'ADMIN',
					regIp: '0:0:0:0',
					chgId: 'ADMIN',
					chgIp: '0:0:0:0',
					msgKey: row.msgKey,
					scrType: row.scrType && row.scrType.length > 1 ? row.scrType.substr(0, 1) : row.scrType
				};

				sendData.data.push(pushSet);
			});

			// console.log('@@@@ sendData: ', sendData);
			if (sendData.data !== undefined && sendData.data.length > 0) {
				this.$sf_toggleLoading(true);
				this.setMenus_(sendData)
					.then(response => {
						if (response.message != undefined && response.message != null) {
							this.$sf_toast({
								type: response.code === 0 ? 'ok' : 'error',
								message: this.getMessage_(response.messageCd)
							});
						}
						this.resetTable();
					})
					.catch(e => {
						this.$sf_toast({
							type: 'error',
							message: e.message ? e.message : e
						});
						Promise.reject(error);
					})
					.finally(() => {
						this.$sf_toggleLoading(false);
					});
			}
		},
		test() {
			// console.log('test');
		},
		changedPage({ currentPageVal, pageUnitVal, prePage, prePageUnit }) {
			this.$emit('Refresh', currentPageVal, pageUnitVal);
		},
		objectSpanMethod({ row, column, rowIndex, columnIndex }) {
			// 필요없는 코드?
			return false;
			// console.log('@@@@ objectSpanMethod');
			// console.log(this.$refs.dataTable.tableRows);
			this.currentTableData = this.$refs.dataTable.tableRows;
		},
		setScrId() {
			if (this.menuKey === null) {
				this.$sf_toggleLoading(true);
				this.getMenuKey_()
					.then(row => {
						let rows = this.$refs.dataTable.tableRows;
						for (let i = 0; i < rows.length; i++) {
							if (rows[i].rowType === 'add') {
								// rows[i].scrId = 'S' + (parseInt(rows[i - 1].scrId.substr(1, 8)) + 1).toString().padStart(8, '0');
								rows[i].scrId = this.menuKey;
							}
						}
					})
					.catch(error => {
						this.$sf_toast({
							type: 'error',
							message: error.message
						});
						Promise.reject(error);
					})
					.finally(() => {
						this.$sf_toggleLoading(false);
					});
			} else {
				this.$refs.dataTable.addedRows[0].scrId = this.menuKey;
			}

			let rows = this.$refs.dataTable.getSelectedRows();
			for (let i = 0; i < rows.length; i++) {
				if (i > 0 && rows[i].rowType === 'add') {
					rows[i].scrId = 'S' + (parseInt(rows[i - 1].scrId.substr(1, 8)) + 1).toString().padStart(8, '0');
				}
			}
		},
		scrNameClick(row) {
			this.editRow = row;
			this.$emit('PopupOpen');
		},
		setMenuName(param) {
			// console.log('@@@@ call setMenuName');
			this.editRow.msgKey = param.msgKey;
			this.editRow.scrName = param.msgText;

			let filterd = this.dicMsgManagements.filter(item => item.msgKey === param.msgKey);
			if (filterd.length > 0) {
				this.editRow.scrName = filterd[0].msgText;
			}

			// if (this.editRow.tableState == 'S') {
			// 	this.editRow.tableState = 'U';
			// 	this.$refs.dataTable.updatedRows.push(this.editRow);
			// }

			// 이부분은 어떻게 교체해야할까 필요없을듯?
			// if (this.editRow.rowType === 'add') {
			// 	console.log('@@@@ in add');
			// 	this.$refs.dataTable.updatedRows.push(this.editRow);
			// }
		},
		resetTable() {
			// this.$refs.dataTable.initTableData();
			this.$emit('RefreshAll');
		},
		save(saveRows) {
			try {
				this.schema.validateSync(saveRows);
				// console.log(saveRows);
				// console.log(this.$refs.dataTable.getSelectedRows());

				let sendData = {
					status: 1,
					plantCd: this.searchParams.plantCd,
					data: []
				};

				// this.$refs.dataTable.getSelectedRows();
				saveRows.forEach(row => {
					// console.log(row);
					// add
					if (row.rowType === 'add') {
						row.parentScrId = this.selectedMenu.scrId != undefined ? this.selectedMenu.scrId : null;
						row.scrLv = this.selectedMenu.scrLv != undefined ? parseInt(this.selectedMenu.scrLv) + 1 : 1;
						if (row.scrName == '[화면명 선택]') {
							row.scrName = '';
						}

						let pushSet = {
							scrId: row.scrId,
							scrName: row.scrName ? row.scrName : '',
							scrDesc: row.scrDesc ? row.scrDesc : '',
							parentScrId: row.parentScrId,
							scrLv: row.scrLv,
							scrSort: row.scrSort,
							scrUrl: row.scrUrl,
							useYn: row.useYn,
							regId: 'ADMIN',
							regIp: '0:0:0:0',
							chgId: 'ADMIN',
							chgIp: '0:0:0:0',
							msgKey: row.msgKey,
							scrType: row.scrType && row.scrType.length > 1 ? row.scrType.substr(0, 1) : row.scrType
						};

						sendData.data.push(pushSet);
					} else {
						// update
						row.parentScrId = this.selectedMenu.scrId != undefined ? this.selectedMenu.scrId : null;
						row.scrLv = this.selectedMenu.scrLv != undefined ? parseInt(this.selectedMenu.scrLv) + 1 : 1;
						if (row.scrName == '[화면명 선택]') {
							row.scrName = '';
						}

						let pushSet = {
							scrId: row.scrId,
							scrName: row.scrName ? row.scrName : '',
							scrDesc: row.scrDesc ? row.scrDesc : '',
							parentScrId: row.parentScrId,
							scrLv: row.scrLv,
							scrSort: row.scrSort,
							scrUrl: row.scrUrl,
							useYn: row.useYn,
							regId: 'ADMIN',
							regIp: '0:0:0:0',
							chgId: 'ADMIN',
							chgIp: '0:0:0:0',
							msgKey: row.msgKey,
							scrType: row.scrType && row.scrType.length > 1 ? row.scrType.substr(0, 1) : row.scrType
						};

						sendData.data.push(pushSet);
					}
				});

				// console.log('before post: ', sendData);
				if (sendData.data !== undefined && sendData.data.length > 0) {
					// console.log('in post');
					this.$sf_toggleLoading(true);
					this.setMenus_(sendData)
						.then(response => {
							// console.log('@@@@ response: ', response);
							if (response.code === 0 || response.code === 3) {
								this.$sf_toast({
									type: response.code === 0 ? 'ok' : 'error',
									message: this.getMessage_(response.messageCd)
								});
							}
							this.resetTable();
						})
						.catch(e => {
							this.$sf_toast({
								type: 'error',
								message: e.message ? e.message : e
							});
							Promise.reject(error);
						})
						.finally(() => {
							this.$sf_toggleLoading(false);
						});
				}
			} catch (error) {
				this.$sf_toast({ type: 'error', message: error.message });
			}
		},
		saveClick() {
			if (this.$refs.table.getSelectedRows.length < 1) {
				// title 선택한 정보가 없습니다.\
				// message 저장 할 데이터를 선택해 주세요.
				this.$showMessage({ title: this.getMessage_('SWCC000417'), message: this.getMessage_('SWCC000434') });
				return;
			}

			this.$showMessage({
				type: 'confirm',
				message: this.getMessage_('SWCC000555'), // 저장하시겠습니까?
				buttons: [{ title: 'Ok', clickFn: this.save }]
			});
		},
		menuKeyClick() {
			this.$emit('PopupOpen');
		}
	},
	created() {
		this.screen = this.screenArray.get(this.onstieScrId);

		this.column[4].options = this.gridScrType;
		this.column[6].options = this.gridUseYnList;

		for (let i = 1; i < 20; i++) {
			this.sortOrder.push({
				label: i,
				value: i
			});
		}
		this.column[5].options = this.sortOrder;
	},
	watch: {
		currentTableData(newValue, oldValue) {
			// console.log('@@@@ this.$refs.dataTable: ', this.$refs.dataTable);
			// console.log(this.$refs.dataTable.addedRows);
			if (this.$refs.dataTable.addedRows && this.$refs.dataTable.addedRows.length > 0) {
				//this.setScrId();
			}
		}
	}
};
</script>

<style>
.table-section-container {
	width: 78%;
	display: flex;
	flex-direction: column;
}
</style>
